import React, {useState} from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import {FieldViewSize} from "../../../../../const";
import {LifecycleAction} from "../../../../../../gd/const/lifecycle";
import {FieldEditableMode} from "../../../../../proto/render/editable";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import TasksViewManager from "../../../../../../gd-modules/tasks-view/core/manager"

// this is very default table cell
// unlike other proto render componetns this really does the job
// not sure why yet but I think it some cases we want to re-write the entire cell compoenent
// so I give it a layer - if need custom table cell see this class as example

export default function FieldCheckbox_TableCell(props:FieldTableCellProps):React.ReactElement {

    const [count, setCount] = useState(0);

    const reRender = () => {
        setCount(count + 1);
    };

    const canEdit = !props.manager.isReadOnly && props.field.canEdit(props.listItem.item)


    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (!canEdit) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }




    const value = props.field.getViewValue(props.listItem.item)

    const toggleValue = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!canEdit) return

        onChange(!value)
    }


    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field

        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.task.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.task.save()

        // reRender()

        // reRender()
        props.listItem.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(props.manager as TasksViewManager, props.field)
    }


    const classes = Classes("ui5-field-editable w-100-percent h-100-percent", "size-small", props.className, {
        'is-hovered'        : mode === FieldEditableMode.HOVERED
    })

    const checkboxClasses = Classes("ui5-cb", "s-{0}".f(props.field.size), {
        selected: value
    });

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>

            <div className={classes} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={toggleValue}>
                <div className={checkboxClasses} onClick={toggleValue}/>
            </div>

            {/*<props.field.renderComponents.editable size={FieldViewSize.SMALL}*/}
            {/*                                       className="w-100-percent h-100-percent"*/}
            {/*                                       disabled={props.manager.isReadOnly}*/}
            {/*                                       field={props.field}*/}
            {/*                                       model={props.listItem.item}*/}
            {/*                                       onChange={props.onChange ? props.onChange : onChange} />*/}

        </div>

    )

}
